import { useEffect, useRef } from "react";
import { Polygon, useMap } from "react-leaflet";

const DestinationPointer = ({ index, vehicleNumber, sourceAndDestination }) => {
  const polygonRef = useRef();
  const map = useMap();

  useEffect(() => {
    return () => {
      if (polygonRef.current && map) {
        map.removeLayer(polygonRef.current);
      }
    };
  }, [index, map]);

  if (!sourceAndDestination) return null;

  return (
    <div key={vehicleNumber} className="destination-pointers">
      <Polygon
        pathOptions={{
          color: "black",
          zIndex: 1006,
          className: "destination-pointer-path",
        }}
        positions={sourceAndDestination}
        weight={1}
        ref={(layer) => {
          if (layer) {
            polygonRef.current = layer;
          }
        }}
      />
    </div>
  );
};

export default DestinationPointer;
